<template>
     <form @keyup.enter="login">
          <set-language :title="`interface_language`"></set-language>
           <fg-input
            type="tel"
            label="Номер телефона"
            v-model="phone"
            name="phone"
           
            v-mask="'+998#########'"
            placeholder="+998"
          ></fg-input>
          <fg-input

            type="password"
            name="password"
            label="Пароль"
            v-model="password"
            placeholder="Пароль"
          ></fg-input>
          <br />
          <p-button
            class="w-100 mb-3"
            type="warning"
            round
            @click.native.prevent="login"
            >{{'login' | setText('Войти в систему')}}</p-button
          >
          </form>

</template>

<script>
import { errorNotify } from "@/plugins/functions";

export default {
  name: "login",
  components: {},
  mounted() {},
  data() {
    return {
      phone: "",
      password: "",
    };
  },
  methods: {
    login(loading = true) {
      this.$loading(true);
      this.$http
        .post("auth/login", {
          phone: this.phone,
          password: this.password,
        })
        .then((response) => {
              let token = response.data.data.access.accessToken;
              this.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
              this.$http.defaults.headers.common["root"] = null;
              this.$http.defaults.headers.common["bid"] = null;
              localStorage.setItem("token", `Bearer ${token}`);
              localStorage.removeItem('root');
              localStorage.removeItem('bid');
              this.$store.dispatch("setUser", response.data.data);
              this.$store.dispatch("setRoot", false);
              this.$store.dispatch("setBusiness", null);
              this.$store.dispatch("setRoles", response.data.data.roles);
              this.$store.dispatch("setLocations", response.data.data.locations);

        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
